import { providerService } from '@/api'

const initialState = () => ({
  name: null,
  all: []
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async find({ commit, state }) {
      try {
        // if (state.all.length) return state.all
        console.log('fetch from provider', state.name)
        const result = await providerService.find({
          service: state.name
        })
        commit('assign', result)
        return result
      } catch (err) {
        console.error(err)
      }
    },
    name({ commit }, serviceName) {
      commit('name', serviceName)
    }
  },
  mutations: {
    assign(state, data) {
      state.all = data
    },
    name(state, data) {
      state.name = data
    }
  }
}
